import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, FileCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProtectionPage() {
  const features = [
    {
      title: "Life Insurance",
      desc: "Ensuring your family's financial stability by providing a lump sum payment in the event of your passing, helping them maintain their lifestyle and meet future needs.",
    },
    {
      title: "Life Insurance with Critical Illness Cover",
      desc: "Offering additional protection that supports you and your family financially if you're diagnosed with a serious illness, so you can focus on recovery without financial stress.",
    },
    {
      title: "Family Income Benefit",
      desc: "Providing regular income to your loved ones in the event of your passing, ensuring their day-to-day living costs are covered for a specified period.",
    },
    {
      title: "Income Protection",
      desc: "Protecting your income if you're unable to work due to illness or injury, helping you meet essential expenses and maintain your financial security.",
    },
    {
      title: "Relevant Life Cover",
      desc: "A tax-efficient life insurance policy for business owners, offering financial protection for your family while benefiting from cost-effective premiums through your business.",
    },
  ];

  return (
    <div data-testid="protection-page">
      <section className="relative bg-[#111111] py-32 lg:py-40">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=80')] bg-cover bg-center opacity-15" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#d64241] font-semibold text-sm tracking-widest uppercase mb-3 font-body">Protection Service</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Protection<br />
            <span className="text-[#d64241]">Services</span>
          </h1>
        </div>
      </section>

      <section data-testid="protection-content" className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="w-14 h-14 rounded-xl bg-[#fef2f2] flex items-center justify-center mb-6">
                <FileCheck className="w-7 h-7 text-[#d64241]" />
              </div>
              <h2 className="text-3xl md:text-4xl font-semibold text-black tracking-tight mb-6">
                Comprehensive Protection Plans
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                At KK Mortgage Solutions, we understand that protecting your loved ones and securing your financial future is just as important as finding the right mortgage. That's why we offer a wide range of protection services designed to provide peace of mind and safeguard what matters most.
              </p>
              <div className="space-y-6 mb-10">
                {features.map((f, i) => (
                  <div key={i} className="flex gap-4">
                    <CheckCircle2 className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-black mb-1">{f.title}</h3>
                      <p className="text-sm text-gray-600 font-body leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                We're committed to providing expert advice, tailored solutions, and complete transparency. Our mission is to help you secure a brighter, more secure future for yourself and your family with protection plans designed around your unique needs.
              </p>
              <Link to="/contact">
                <Button data-testid="protection-cta-btn" className="bg-[#d64241] hover:bg-[#b53736] text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-[#d64241]/25 hover:-translate-y-0.5 transition-all duration-200">
                  Get a Quote <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
                <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80" alt="Protection services" className="w-full h-[400px] lg:h-[550px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
